export const DOCTOR_VISITS_ARTICLE_SLUGS: ReadonlySet<string> = new Set([
  "what-to-do-when-you-need-a-doctor-at-home",
  "doctor-in-antalya-tourist-medical-help",
  "doctor-hotel-visit-antalya",
  "english-speaking-doctor-antalya",
  "private-doctor-antalya-tourist",
  "doctor-hotel-visit-turkey",
]);

export function linksToDoctorVisits(slug: string): boolean {
  return DOCTOR_VISITS_ARTICLE_SLUGS.has(slug);
}
